<template lang="pug">
  div.careers
    Header
    b-container
      div.mt-5.pt-5
        h2.text-center.mb-5 Our distinct traits
        div.small-container.text-gray
          b-row(align-v="center").mx-md-2
            b-col(cols="4" md="2").text-center
              img(src="@/assets/icons/career-icon-1.svg")
            b-col
              b Open and diverse culture,
              | with 7 nationalities in the team, originating from private capital, consulting and tech
          hr
          b-row(align-v="center").mx-md-2
            b-col(cols="4" md="2").text-center
              img(src="@/assets/icons/career-icon-2.svg")
            b-col
              b Curiosity and entrepreneurship,&nbsp;
              | in our client products, as well as in our ways of working
          hr
          b-row(align-v="center").mx-md-2
            b-col(cols="4" md="2").text-center
              img(src="@/assets/icons/career-icon-3.svg")
            b-col
              b Enthusiastic about data,&nbsp;
              | central to everything we do
          hr
          b-row(align-v="center").mx-md-2
            b-col(cols="4" md="2").text-center
              img(src="@/assets/icons/career-icon-4.svg")
            b-col
              b Innovative&nbsp;
              | approaches and solutions to the problems (opportunities) we face, and the solutions we build
          hr
          b-row(align-v="center").mx-md-2
            b-col(cols="4" md="2").text-center
              img(src="@/assets/icons/career-icon-5.svg")
            b-col
              | A constant dedication to business issues, backed by in depth&nbsp;
              b industry and market insights
          hr
      div.careers-quote
        | A fantastic opportunity to actively take part in the early stages of a high-growth data & software company.
      div.mt-5(id="jobs")
        h2.text-center.mb-5 Job openings
        b-list-group.careers-list.text-gray
          b-list-group-item(v-for="(job, idx) in jobs" :key="idx").d-md-flex.justify-content-between.align-items-center
            div
              img(src="@/assets/icons/file-document-outline.svg").mr-2
              b {{ job.title }}&nbsp;
              span(v-if="job.languages") {{ job.languages }}&nbsp;
              span(v-if="job.countries")
                img(src="@/assets/icons/point.svg" width="18").mr-1
                | {{ job.countries }}
            router-link(v-if="job.url" :to="job.url").d-flex.more.mt-md-0.mt-2
              | Details
              img(src="@/assets/icons/arrow-right-thin.svg").more-img
      div.mt-5
        | To apply, or for questions:&nbsp;
        a(href="mailto:careers@mktbi.com") careers@mktbi.com
    Footer
</template>

<script>
import Footer from "@/components/Shared/Footer";
import Header from "./components/Header";
import VueScrollTo from "vue-scrollto";

export default {
  name: "Careers",
  components: {Header, Footer},
  data() {
    return {
      jobs: [
        {
          title: 'Private equity analyst',
          languages: 'fluent German, Dutch, Swedish, Danish or Norwegian',
          countries: 'London',
          url: {name: 'view-job', params: {job: 'private-equity-analyst-london'}}
        },
        {
          title: 'Head of offshore operations',
          countries: 'India',
          url: {name: 'view-job', params: {job: 'head-offshore-operations'}}
        },
        {
          title: 'Private equity analyst',
          countries: 'India',
          url: {name: 'view-job', params: {job: 'private-equity-analyst-india'}}
        }
      ]
    }
  },
  beforeMount() {
    VueScrollTo.scrollTo({y: 0})
  }
}
</script>

<style scoped lang="scss">
.careers {
  h2 {
    font-size: 40px;
    font-weight: 700;
    color: #364149;
  }

  &-quote {
    margin-top: 80px;
    background: #4472c4;
    color: white;
    padding: 70px 30px;
    text-align: center;
    line-height: 1.4;
    font-size: 24px;

    @media(min-width: 960px) {
      padding: 155px 0;
      font-size: 40px;
      line-height: 45px;
    }
  }

  &-list {
    > * {
      border-bottom: 1px solid #333;
      border-top: 0;
      border-left: 0;
      border-right: 0;
    }
  }

  .text-gray {
    color: #707980;
  }

  .more {
    color: #000;
    position: relative;

    &-img {
      transition: .3s;
    }

    &:hover {
      img {
        transform: translateX(10px);
      }
    }
  }
}

.small-container {
  @media(min-width: 960px) {
    width: 70%;
    margin: 0 auto;
  }
}

hr {
  border-bottom: #01b0ef 3px solid;
}
</style>